<app-base-edit-form [fields]="fields" [baseService]="userService" [closeOnSave]="false" (saved)="saved.emit()">
</app-base-edit-form>
